import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { authAPI, getConfig, homeUrl } from "../../apis";
import { useSelector } from "react-redux";
import DeleteUser from "./DeleteUser";
import UserForm from "./UserForm";
import { toast } from "react-toastify";
import Loader from "../../components/loader";
import Table from "./Table";
import Paginate from "./Paginate";
import Header from "./Header";
import { axiosInstance } from "../../functions/axios";

function AdminPage() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentUsers, setCurrentUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [deactivate, setDeactivate] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newUser, setNewUser] = useState(false);
  const [sort, setToSort] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    usersPerPage: 50,
    totalPages: 0,
    paginationRange: {
      start: 1,
      end: 1,
    },
  });
  let newTab;

  const { user } = useSelector((state) => state.auth);

  const sortFilteredUsers = (col, toSort) => {
    let arr;
    if (col === "userName") {
      if (toSort === false) arr = users;
      else {
        arr = [...filteredUsers].sort(function (a, b) {
          return a.userName < b.userName ? 1 : -1;
        });
      }
    } else if (toSort) {
      arr = [...filteredUsers].sort(function (a, b) {
        var dateA = new Date(a[col]).getTime();
        var dateB = new Date(b[col]).getTime();
        return dateA < dateB ? 1 : -1; // ? -1 : 1 for ascending/increasing order
      });
    } else {
      arr = users;
    }
    setFilteredUsers(arr);
    setCurrentUsers(arr.slice(0, pagination.usersPerPage));
  };

  const paginate = (pageNumber) => {
    const start = Math.max(pageNumber - 2, 1);
    const end = Math.min(pageNumber + 2, pagination.totalPages);
    setPagination((prev) => ({
      ...prev,
      currentPage: pageNumber,
      paginationRange: { start, end },
    }));
  };

  const deleteUser = async (id) => {
    try {
      setLoading(true);
      await axiosInstance.delete(
        `${authAPI.deactivateUser}/?id=${id}&isInactive=${!deactivate}`,
        getConfig()
      );
      deactivate
        ? toast.success("User Status successfully activated")
        : toast.success("User Status successfully deactivated");
    } catch {
      toast.error("Some error occured while deleting user");
      setLoading(false);
    }
    getData();
  };

  const handleDelete = (user) => {
    setId(user.id);
    setDeactivate(user.isDeleted);
    setDeletePopup(true);
  };

  const handleSearch = (search) => {
    setSearchTerm(search);
    const searchedUsers = users.filter((user) =>
      user.userName.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredUsers(searchedUsers);
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const updateUser = async (requestsData) => {
    try {
      setLoading(true);
      await axiosInstance.post(
        `${authAPI.updateUser}?id=${requestsData.id}`,
        requestsData,
        getConfig()
      );
      toast.success("User Updated Successfully");
    } catch {
      toast.error("An Error occured while updating user");
    }
    getData();
  };

  const addUser = async (requestsData) => {
    try {
      setLoading(true);
      await axiosInstance.post(
        `${authAPI.createUser}`,
        requestsData,
        getConfig()
      );
      toast.success("New User added successfully");
    } catch {
      toast.error("An error occured while creating new user");
    }
    getData();
  };

  const switchUser = async (user) => {
    try {
      const { data } = await axiosInstance.post(
        `${authAPI.switchUser}?Id=${user.id}`,
        { id: user.id },
        getConfig()
      );

      const sessionStorageData = {
        key: "user",
        value: JSON.stringify(data),
      };

      newTab = window.open(homeUrl(), "_blank");

      const loadHandler = () => {
        newTab.postMessage(
          { action: "setSessionStorage", payload: sessionStorageData },
          "*"
        );
        newTab.removeEventListener("load", loadHandler);
      };

      newTab.addEventListener("load", loadHandler);

      return () => {
        newTab.removeEventListener("load", loadHandler);
      };
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (id) => {
    setId(id);
    setPopUp(true);
  };

  const getData = async () => {
    const res = await axiosInstance.get(authAPI.getUsers, {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
    setUsers(res.data);
    setFilteredUsers(res.data);

    if (searchTerm) {
      const searchedUsers = res.data.filter((user) =>
        user.userName.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredUsers(searchedUsers);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!user.roles.includes("Admin")) {
      window.location.reload();
      window.location.href = "/";

      return <>Error</>;
    }
  }, []);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const totalPages = Math.ceil(
      filteredUsers.length / pagination.usersPerPage
    );
    const paginationRangeStart = Math.max(pagination.currentPage - 2, 1);
    const paginationRangeEnd = Math.min(pagination.currentPage + 2, totalPages);
    const paginationRange = {
      start: paginationRangeStart,
      end: paginationRangeEnd,
    };
    setPagination((prevPagination) => ({
      ...prevPagination,
      totalPages: totalPages,
      paginationRange: paginationRange,
    }));
  }, [filteredUsers, pagination.currentPage, pagination.usersPerPage]);

  useEffect(() => {
    const lastIndex = pagination.currentPage * pagination.usersPerPage;
    const firstIndex = lastIndex - pagination.usersPerPage;
    const newCurrentUsers = filteredUsers.slice(firstIndex, lastIndex);
    setCurrentUsers(newCurrentUsers);
  }, [filteredUsers, pagination.currentPage, pagination.usersPerPage]);

  if (loading) {
    return (
      <div className="admin-content-loading">
        <Loader />
      </div>
    );
  }

  return (
    <div className="admin-page">
      <nav className="admin-nav">
        <ul>
          <li>
            <Link to="/admin">Users</Link>
          </li>
          <li className="create-user">
            <a
              onClick={() => {
                setPopUp(true);
                setNewUser(true);
              }}
            >
              Create User
            </a>
          </li>
        </ul>
      </nav>
      <div className="container admin-content">
        <Header
          searchTerm={searchTerm}
          handleSearch={handleSearch}
          users={users}
          setPagination={setPagination}
        />
        <div className="table-container">
          <Table
            currentUsers={currentUsers}
            length={filteredUsers.length}
            sortFilteredUsers={sortFilteredUsers}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            pagination={pagination}
            switchUser={switchUser}
            users={users}
          />
        </div>

        <Paginate paginate={paginate} pagination={pagination} />

        {deletePopup && (
          <DeleteUser
            deletePopup={deletePopup}
            setDeletePopup={setDeletePopup}
            id={id}
            deleteUser={deleteUser}
            isDeactivated={deactivate}
          />
        )}
        {popUp && (
          <UserForm
            popUp={popUp}
            setPopUp={setPopUp}
            updateUser={updateUser}
            user={currentUsers[id]}
            newUser={newUser}
            setNewUser={setNewUser}
            addUser={addUser}
          />
        )}
      </div>
    </div>
  );
}

export default AdminPage;
